import {User, UserManagementModel} from '../../user-management/user-management.model';
export class GroupDetailsModel {
  public id: number;
  public name = 'New Group';
  public address: string;
  public note: string;
  public venues = new Array<GroupDetailsVenueModel>();
  public contacts = new Array<GroupDetailsContactModel>();
  public users = new Array<User>();
}
export class GroupDetailsVenueModel {
  public id: number;
  public name: string;
  public note: string;
  public subsidieries = new Array<GroupDetailsVenueSubsidiaryModel>();
}
export class GroupDetailsVenueSubsidiaryModel {
  public type: string;
  public status: string;
  public ratePerCover = 0;
}
export class GroupDetailsContactModel {
  public id: number;
  public contactName: string;
  public contactEmail: string;
  public contactOfficePhone: string;
  public contactMobilePhone: string;
  public position: string;
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/create-group/create-group.model.ts